"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TELE_CONSULTANT_REDUCER = exports.HOMECARE_REDUCER = exports.EPHARMACY_REDUCER = exports.EPHARMACY_NOT_PERSIST_REDUCER = exports.DOD_REDUCER = exports.COMMON_UTILS_REDUCER = exports.ASTER_CORE_REDUCER = void 0;
const ASTER_CORE_REDUCER = exports.ASTER_CORE_REDUCER = 'astercore';
const TELE_CONSULTANT_REDUCER = exports.TELE_CONSULTANT_REDUCER = 'teleconsultant';
const EPHARMACY_REDUCER = exports.EPHARMACY_REDUCER = 'epharmacy';
const EPHARMACY_NOT_PERSIST_REDUCER = exports.EPHARMACY_NOT_PERSIST_REDUCER = 'epharmacyNotPersist';
const DOD_REDUCER = exports.DOD_REDUCER = 'dod';
const COMMON_UTILS_REDUCER = exports.COMMON_UTILS_REDUCER = 'commonUtilsReducer';
const HOMECARE_REDUCER = exports.HOMECARE_REDUCER = 'homecare';